const resources = [
  {
    title: "U.S. State Department — Passport Information",
    url: "https://travel.state.gov/content/travel/en/passports.html",
    description:
      "Official passport requirements, forms, processing times, and eligibility guidelines from the U.S. Department of State. This is the authoritative source for all passport rules.",
    icon: "ri-government-line",
  },
  {
    title: "U.S. State Department — Travel Advisories",
    url: "https://travel.state.gov/content/travel/en/traveladvisories/traveladvisories.html",
    description:
      "Real-time travel advisories for every country worldwide. Essential for Marco Island travelers heading to the Bahamas, Mexico, Europe, or anywhere abroad. Entry requirements change frequently.",
    icon: "ri-alert-line",
  },
  {
    title: "USPS Marco Island Passport Services",
    url: "https://tools.usps.com/find-location.htm",
    description:
      "Find the nearest USPS passport acceptance facility. Search by ZIP code 34145 for Marco Island locations. Call ahead for appointments — walk-ins are rarely accepted.",
    icon: "ri-map-pin-line",
  },
  {
    title: "Southwest Florida International Airport (RSW)",
    url: "https://www.flylcpa.com/",
    description:
      "RSW is Marco Island's primary commercial airport, roughly 45–50 minutes north via I-75 and Collier Boulevard. Check international flight schedules, customs requirements, and seasonal routes to Toronto, Montreal, London, and Frankfurt.",
    icon: "ri-plane-line",
  },
  {
    title: "Collier County Government",
    url: "https://www.colliercountyfl.gov/",
    description:
      "Official Collier County website with information on county clerk services, notarization, public records, and local government offices that support passport and travel document needs.",
    icon: "ri-building-line",
  },
  {
    title: "U.S. Customs and Border Protection — Real ID",
    url: "https://www.dhs.gov/real-id",
    description:
      "REAL ID requirements for domestic flights. As of May 2025, a REAL ID-compliant driver's license or passport is required for all domestic air travel. Marco Island residents should verify their Florida driver's license compliance before any trip.",
    icon: "ri-id-card-line",
  },
];

export default function MarcoIslandHelpfulResourcesSection() {
  return (
    <section id="local-resources" className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Helpful Links
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Resources for Marco Island Travelers
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Official links and tools every Marco Island, FL traveler should bookmark before planning international travel.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {resources.map((r, i) => (
            <a
              key={i}
              href={r.url}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="group bg-white rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all hover:shadow-md"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#1A365D] flex items-center justify-center shrink-0 group-hover:bg-[#F6C344] transition-colors">
                  <i className={`${r.icon} text-[#F6C344] group-hover:text-[#1A365D] transition-colors text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-semibold text-[#1A365D] text-sm mb-1 group-hover:text-[#B22222] transition-colors">
                    {r.title}
                    <i className="ri-external-link-line ml-1.5 text-[10px] text-gray-400"></i>
                  </h3>
                  <p className="text-gray-600 text-xs leading-relaxed">{r.description}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}